<template>
  <mp-box
    id="qon-header"
    as="nav"
    border-bottom-color="gray.100"
    border-bottom-width="1px"
    border-style="solid"
    background-color="white"
    padding-x="6"
    padding-y="2"
    height="60px"
  >
    <mp-flex
      flex-direction="row"
      justify-content="space-between"
      align-items="center"
    >
      <mp-flex
        id="qon-header-left-side"
        flex-direction="row"
        justify-content="space-between"
        align-items="center"
      >
        <!-- Logo on mobile -->
        <mp-box
          id="qon-header-logo"
          as="router-link"
          to="/"
          bg-color="sky.400"
          rounded="full"
          p="1.5"
          :display="{
            xl: 'none',
            lg: 'none',
            md: 'none',
            sm: 'block',
            xs: 'block',
          }"
        >
          <img
            src="@/assets/images/brands/new/qontak-c.svg"
            alt="Mekari Qontak Chat"
          />
        </mp-box>
        <!-- Logo on desktop -->
        <mp-box
          id="qon-header-logo"
          as="router-link"
          to="/"
          :display="{
            xl: 'block',
            lg: 'block',
            md: 'block',
            sm: 'none',
            xs: 'none',
          }"
        >
          <img
            src="@/assets/images/brands/new/logo-qontak-default.svg"
            alt="Mekari Qontak Chat"
          />
        </mp-box>
        <template
          v-if="!isQontakLitePackage && isNotRestrictedPage && !isLoadingHeader"
        >
          <!-- Divider -->
          <mp-box
            ml="4"
            height="1.5rem"
            border="1px"
            color="gray.100"
            :display="{
              xl: 'block',
              lg: 'block',
              md: 'block',
              sm: 'none',
              xs: 'none',
            }"
          >
          </mp-box>
          <!-- Switcher Product -->
          <mp-box
            ml="4"
            :display="{
              xl: 'block',
              lg: 'block',
              md: 'block',
              sm: 'block',
              xs: 'block',
            }"
          >
            <mp-popover id="header-app-switcher-popover" use-portal>
              <mp-popover-trigger>
                <mp-button
                  color="gray.600"
                  variant="link"
                  right-icon="caret-down"
                  margin-y="2"
                >
                  Omnichannel
                </mp-button>
              </mp-popover-trigger>
              <mp-popover-content
                max-width="64"
                bg="white"
                rounded="md"
                shadow="lg"
                border-width="1px"
                border-color="gray.400"
              >
                <mp-popover-list>
                  <mp-box width="full" padding-x="3" padding-y="2">
                    <mp-text color="gray.600" font-size="sm" text-align="left">
                      SELECT APPS
                    </mp-text>
                  </mp-box>
                  <mp-popover-list-item>
                    Omnichannel
                    <mp-icon name="check" size="sm" margin-right="2" />
                  </mp-popover-list-item>
                  <mp-popover-list-item @click="switchToCrm()">
                    CRM
                  </mp-popover-list-item>
                  <mp-popover-list-item
                    v-if="kbInfo.kb_active"
                    @click="switchToKB()"
                  >
                    <mp-text> Knowledge Base </mp-text>
                  </mp-popover-list-item>
                  <mp-popover-list-item
                    v-if="isAppointmentEntryVisible"
                    @click="switchToAppointment()"
                  >
                    <mp-text> Appointment </mp-text>
                    <mp-badge>Beta</mp-badge>
                  </mp-popover-list-item>
                  <mp-popover-list-item
                    v-if="
                      appConfig &&
                      appConfig.is_launchpad &&
                      $auth &&
                      $auth.user?.is_launchpad_superadmin &&
                      isQontakSuiteOrg
                    "
                    style="border-top: 1px solid #dcdfe4"
                    pt="4"
                    @click="switchToLaunchpad()"
                  >
                    Admin console
                  </mp-popover-list-item>
                  <mp-popover-list-item
                    v-if="appConfig && isCanAccessInsight && !isAgent()"
                    style="border-top: 1px solid #dcdfe4"
                    pt="4"
                    @click="switchToInsight()"
                  >
                    <mp-text> Insight </mp-text>
                    <mp-badge variant-color="red">New</mp-badge>
                  </mp-popover-list-item>
                </mp-popover-list>
              </mp-popover-content>
            </mp-popover>
          </mp-box>
        </template>
      </mp-flex>
      <template v-if="isNotRestrictedPage">
        <mp-flex align-items="center" height="100%" gap="2">
          <template v-if="!isLoadingHeader && (isSupervisor() || isAgent())">
            <mp-box ref="offlinePopover">
              <mp-popover
                id="online-offline-popover"
                :is-open="showOnlineOfflineAlert"
                is-manual
              >
                <mp-popover-trigger>
                  <mp-flex class="centered-item">
                    <mp-toggle
                      id="qon-header-content-online-toggle"
                      v-model="is_online"
                      :is-disabled="loading.toggle"
                      m="0"
                      @change="onToggleStatusChange"
                      >{{ is_online ? 'Online' : 'Offline' }}</mp-toggle
                    >
                  </mp-flex>
                </mp-popover-trigger>
                <mp-popover-content
                  max-width="17rem"
                  bg-color="white"
                  p="4"
                  border-radius="md"
                  border="1px solid"
                  border-color="gray.100"
                >
                  <mp-text font-weight="semibold" font-size="md"
                    >You're offline</mp-text
                  >
                  <mp-text
                    >Switching online will allow you to be assigned
                    automatically.</mp-text
                  >
                </mp-popover-content>
              </mp-popover>
            </mp-box>
          </template>
          <mp-box id="qon-header-content-help" class="centered-item" px="2">
            <mp-popover id="header-help-popover">
              <mp-popover-trigger>
                <mp-box as="button">
                  <mp-tooltip position="bottom" label="Help center">
                    <mp-icon name="help"></mp-icon>
                  </mp-tooltip>
                </mp-box>
              </mp-popover-trigger>
              <mp-popover-content
                max-width="64"
                bg-color="white"
                p="4"
                border-radius="md"
                border="1px solid"
                border-color="gray.100"
              >
                <mp-text font-size="xs" color="gray.600">Resources</mp-text>
                <mp-pseudo-box
                  :_hover="{
                    backgroundColor: 'ice.50',
                    color: 'blue.400',
                    cursor: 'pointer',
                  }"
                  px="1"
                >
                  <mp-flex
                    mt="2"
                    mb="3"
                    cursor="pointer"
                    @click="
                      openTab(
                        'https://help-center.qontak.com/hc/id/articles/5703349565209-Omnichannel-Frequently-Asked-Questions-FAQs-'
                      )
                    "
                  >
                    <mp-icon name="chat" mr="2" size="sm" />
                    <mp-text size="sm">FAQ</mp-text>
                  </mp-flex>
                </mp-pseudo-box>
                <mp-text font-size="xs" color="gray.600">Help</mp-text>
                <mp-pseudo-box
                  :_hover="{
                    backgroundColor: 'ice.50',
                    color: 'blue.400',
                    cursor: 'pointer',
                  }"
                  px="1"
                >
                  <mp-flex
                    mt="2"
                    cursor="pointer"
                    @click="openTab('https://app.qontak.com/contact-support')"
                  >
                    <img
                      src="@/assets/images/icons/icon-whatsapp.svg"
                      alt="Whatsapp"
                      width="20"
                    />
                    <mp-text size="sm" ml="2">Customer Support</mp-text>
                  </mp-flex>
                </mp-pseudo-box>
              </mp-popover-content>
            </mp-popover>
          </mp-box>
          <template v-if="isSubscribeInboxPackage">
            <NotificationCenter
              v-if="isNotificationServiceEnabled"
              id="qontak-one-notification-center"
              ref="notificationCenter"
              :sso-token="ssoToken"
              :env="nodeEnv"
              @select="notificationClickHandle"
              @notification-center-open="onNotificationOpen"
              @unread-toggle-change="onUnreadToggleChange"
              @read="onMarkAsRead"
              @mark-all-as-read="onMarkAllAsRead"
              @filter-change="onFilterChange"
            />
            <NotificationBell v-else id="qontak-one-notification-center" />
          </template>
          <mp-box id="qon-header-content-switcher">
            <mp-tooltip position="bottom" label="Switch app">
              <mp-button-icon
                name="shortcuts"
                size="md"
                @click="isSwitchAppOpen = !isSwitchAppOpen"
              />
            </mp-tooltip>
          </mp-box>
          <SwitchAccount
            v-if="true"
            :is-loading="isLoadingHeader"
            @onLoggedOut="setStatusToOffline"
          />
        </mp-flex>
      </template>
    </mp-flex>
    <SwitchApp
      v-if="isNotRestrictedPage"
      :is-switch-app-open="isSwitchAppOpen"
      :on-switch-app-toggle="onSwitchAppToggle"
    />
    <transition name="slide-down">
      <StickyToast v-if="stickyToast.isShow" />
    </transition>
  </mp-box>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import { mapState } from 'vuex'
import { NotificationCenter } from 'qontak-unified-component/packages/vue2'
import SwitchApp from './SwitchApp.vue'
import SwitchAccount from './main/SwitchAccount.vue'
import NotificationBell from './main/Notification.vue'
import { NOTIFICATION_CATEGORIES } from './const/typeAndCategory'
import StickyToast from '~/components/UI/StickyToast.vue'
import { isQontakLitePackage, validTokenCookie } from '~/utils/general'
import { PackageName } from '~/store/package'
import {
  getAppointmentUrl,
  hasGlobalSsoSession,
  isAppointmentEntryVisible as checkAppointmentEntryVisible,
} from '~/utils/appointment'
import { EventBus } from '@/plugins/event-bus'

export default {
  name: 'LayoutsHeader',
  components: {
    SwitchApp,
    SwitchAccount,
    NotificationBell,
    StickyToast,
    NotificationCenter,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSwitchAppOpen: false,
      loading: {
        toggle: false,
      },
      showOnlineOfflineAlert: false,
    }
  },
  head() {
    return {
      titleTemplate: `${
        this.info.unassigned ? '(' + this.info.unassigned + ') ' : ''
      }%s - Qontak Chat`,
      link: [
        {
          rel: 'icon',
          type: 'image/x-icon',
          href:
            this.info.unassigned > 0
              ? '/qontak-favicon-unread.png'
              : '/qontak-favicon.ico',
        },
      ],
    }
  },
  computed: {
    ...mapFields('layouts', ['userStatus.is_online']),
    ...mapState('layouts', [
      'appConfig',
      'userStatus',
      'stickyToast',
      'kbInfo',
    ]),
    ...mapState('package', [
      'isUsePackageCode',
      'packageCodes',
      'qontakPackageName',
    ]),
    isUsePackageCode() {
      return this.$store.state.package.isUsePackageCode
    },
    isSubscribeInboxPackage() {
      if (this.isUsePackageCode) {
        return this.$store.getters['package/isEnableBillingPackage'](
          PackageName['CP-QONTAKCHAT-2025-0004']
        )
      }
      return true
    },
    ...mapState('organization', ['app_type', 'permissions']),
    isNotRestrictedPage() {
      return this.$route.path !== '/restricted'
    },
    ...mapState('inbox', ['info']),
    ...mapState('preferences', ['billing_info']),
    isQontakLitePackage() {
      return isQontakLitePackage(this.billing_info)
    },
    isQontakSuiteOrg() {
      return this.billing_info?.package_name.includes('Suites')
    },
    isCanAccessInsight() {
      const cidsList = this.appConfig?.is_company_can_access_insight
      const result = cidsList.includes(
        parseInt(this.credentials?.[0]?.company_id)
      )
      return result
    },
    ...mapState('unified_app', ['isUnifiedApp']),
    /**
     * BIF-9542 — gates the "Appointment [Beta]" switcher entry. The Appointment
     * origin and the shared SSO cookies are not reactive, but every store value
     * read here is: the gate is re-evaluated once app config and package config
     * land, which is after the session cookies have been written.
     */
    isAppointmentEntryVisible() {
      return checkAppointmentEntryVisible({
        appConfig: this.appConfig,
        isUnifiedApp: this.isUnifiedApp,
        isEnableBillingPackage: (packageCode) =>
          this.$store.getters['package/isEnableBillingPackage'](packageCode),
      })
    },
    ssoToken() {
      const isDev = process.env.BASE_URL === 'http://localhost:3000/'
      // change token only for development
      return isDev
        ? 'bearer 15abb8eb-86b5-4c90-8af6-2b2eedf3d007_BgaISrta5b1VlZdGik4Ya3JJRF1jygD3'
        : validTokenCookie()
    },
    nodeEnv() {
      return process.env.HUB_ENVIRONMENT === 'production'
        ? 'production'
        : 'staging'
    },
    isNotificationServiceEnabled() {
      return this.permissions?.use_notification_service
    },
    currentRoute() {
      return this.$route.path
    },
    isLoadingHeader() {
      return this.isLoading
    },
  },
  watch: {
    currentRoute(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.resetNotificationCenterFilter()
      }
    },
  },
  created() {
    this.$nuxt.$on('onLoggedOut', () => {
      this.setStatusToOffline()
    })
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
    if (typeof this.$auth?.user?.is_online === 'boolean') {
      this.$store.commit('layouts/UPDATE_USER_STATUS', {
        is_online: this.$auth.user.is_online,
        status: this.$auth.user.is_online ? 'online' : 'offline',
      })
    } else {
      this.$store.commit('layouts/UPDATE_USER_STATUS', {
        is_online: this.userStatus.is_online,
        status: this.userStatus.is_online ? 'online' : 'offline',
      })
    }
    this.checkOnline()
    EventBus.$on('push-to-notification-center', this.pushToNotificationCenter)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
    EventBus.$off('push-to-notification-center', this.pushToNotificationCenter)
  },
  methods: {
    onSwitchAppToggle() {
      this.isSwitchAppOpen = false
    },
    openTab(url) {
      window.open(url)
    },
    switchToCrm() {
      this.$store
        .dispatch('users/getUserByEmail', {
          email: this.$auth.user.email,
          is_crm_check: true,
        })
        .then((res) => {
          let redirectUrl = process.env.CRM_URL
          const dhlCids = this.appConfig.dhl_company_ids

          if (dhlCids.includes(res?.data?.organization?.company_id)) {
            redirectUrl = 'https://dhl.qontak.com'
          }
          this.$toast({
            variant: 'success',
            title: 'You will be redirected to the CRM',
            position: 'top',
          })
          this.$auth.reset()
          setTimeout(() => {
            window.location.replace(
              `${process.env.SSO_URL}/auth/?client_id=${process.env.SSO_UNIFIED_CLIENT_ID}&response_type=code&scope=sso:profile&redirect_uri=${redirectUrl}/sso-callback`
            )
          }, 1000)
        })
        .catch((err) => {
          if (err) {
            return this.$toast({
              variant: 'error',
              title: this.billing_info?.is_trial
                ? 'Your CRM account is being created. Try again in a few minutes'
                : 'Your account is unregistered to Qontak CRM yet. Contact our support team for further info',
              position: 'top',
            })
          }
        })
    },
    switchToLaunchpad() {
      const redirectUrl = process.env.QONTAK_LAUNCHPAD_URL
      window.location.replace(
        `${process.env.SSO_URL}/auth/?client_id=${process.env.SSO_UNIFIED_CLIENT_ID}&response_type=code&scope=sso:profile&redirect_uri=${redirectUrl}/sso-callback/switcher`
      )
    },
    switchToInsight() {
      const redirectUrl = process.env.QONTAK_LAUNCHPAD_URL
      window.location.replace(
        `${process.env.SSO_URL}/auth/?client_id=${process.env.SSO_UNIFIED_CLIENT_ID}&response_type=code&scope=sso:profile&redirect_uri=${redirectUrl}/sso-callback/switcher`
      )
    },
    switchToAppointment() {
      const appointmentUrl = getAppointmentUrl()
      if (!appointmentUrl || !hasGlobalSsoSession()) return

      window.location.replace(appointmentUrl)
    },
    onToggleStatusChange(status) {
      if (status) this.setStatusToOnline()
      else this.setStatusToOffline()
    },
    updateUserStatus(status) {
      this.loading.toggle = true
      this.$store
        .dispatch('layouts/updateUserStatus', {
          is_online: status,
          status: status ? 'online' : 'offline',
        })
        .then(() => {
          setTimeout(() => {
            this.loading.toggle = false
          }, 800)
        })
        .catch(() => {
          setTimeout(() => {
            this.loading.toggle = false
          }, 800)
          this.$toast({
            variant: 'error',
            title: 'Failure to switch status. Try again in second',
            position: 'top',
          })
        })
    },
    setStatusToOnline() {
      this.updateUserStatus(true)
    },
    setStatusToOffline() {
      this.updateUserStatus(false)
    },
    checkOnline() {
      if (this.isAgent() || this.isSupervisor()) {
        if (!this.is_online) this.showOnlineOfflineAlert = true
      }
    },
    closeModalOnlineOfflineAlert() {
      this.showOnlineOfflineAlert = false
    },
    handleClickOutside(e) {
      this.closeModalOnlineOfflineAlert()
    },
    switchToKB() {
      if (this.isSupervisor() || this.isAgent())
        window.location.replace(this.kbInfo.kb_client_url)
      else window.location.replace(`https://${process.env.KB_ADMIN_URL}`)
    },
    notificationClickHandle(notification) {
      this.$nextTick(() => {
        const selectedCategory = NOTIFICATION_CATEGORIES.find(
          (t) => t.id === notification.notif_category
        )

        this.storeQontakOneMixpanelMetric(
          'Click Notification List',
          {
            'Package Name': this.qontakPackageName,
            'Company SSO ID': this.getOrganizationForMetric()['Company ID'],
            'Company Name': this.getOrganizationForMetric()['Company Name'],
            'Qontak User ID': this.$auth.user?.id,
            'Qontak Role': this.$auth.user?.role,
            'Qontak Email': this.$auth.user?.email,
            'Notification Group': selectedCategory
              ? selectedCategory.label
              : 'Unknown',
          },
          'chat',
          'qontak_one'
        )

        if (notification.origin === 'chat') {
          this.handleNotificationOnClick(notification)
        } else {
          this.redirectToCRMLink(notification)
        }
      })
    },
    handleNotificationOnClick(notification) {
      const inboxUrl =
        this.permissions.revamp_inbox || this.permissions.sunset_inbox_v1
          ? '/inbox-v2'
          : '/inbox'
      if (
        notification.extra &&
        notification.extra.room &&
        (notification.extra.room.id || notification.extra.room_id)
      ) {
        this.$router.push(
          `${inboxUrl}?room=${
            notification.extra.room.id || notification.extra.room_id
          }`
        )
      } else {
        this.$router.push(`${inboxUrl}?`)
      }
    },
    redirectToCRMLink(notification) {
      if (notification && notification.click_action_url) {
        window.location.replace(notification.click_action_url)
      } else {
        window.location.replace(process.env.CRM_URL)
      }
    },
    pushToNotificationCenter(notification) {
      if (
        this.$refs.notificationCenter &&
        typeof this.$refs.notificationCenter.pushNotificationToLists ===
          'function'
      ) {
        this.$refs.notificationCenter.pushNotificationToLists(notification)
      }
    },
    onNotificationOpen() {
      if (
        this.isUsePackageCode &&
        !this.packageCodes.includes('CP-QONTAKCRM-2025-0003')
      ) {
        this.$refs.notificationCenter.hideTab('Approval')
      }

      this.storeQontakOneMixpanelMetric(
        'Click Notification Bell',
        {
          Role: this.$auth.user.role,
          Email: this.$auth.user.email,
          'Company ID': this.getOrganizationForMetric()['Company ID'],
          'Company Name': this.getOrganizationForMetric()['Company Name'],
          'Package Name': this.qontakPackageName,
          Route: window.location.href,
        },
        'chat',
        'qontak_one'
      )
    },
    onUnreadToggleChange(value, filter) {
      this.storeQontakOneMixpanelMetric('Show Unread Notification', {
        'Company SSO ID': this.getOrganizationForMetric()['Company ID'],
        'Company Name': this.getOrganizationForMetric()['Company Name'],
        'Package Name': this.qontakPackageName,
        'Qontak User ID': this.$auth.user?.id,
        'Qontak Role': this.$auth.user?.role,
        'Qontak Email': this.$auth.user?.email,
        'Show Unread': value,
        'Notification Group': filter
          ? filter.replaceAll('_', ' ')
          : 'No Group Recorded',
      })
    },
    onMarkAsRead() {
      this.storeQontakOneMixpanelMetric('Mark Notification As Read', {
        'Company SSO ID': this.getOrganizationForMetric()['Company ID'],
        'Company Name': this.getOrganizationForMetric()['Company Name'],
        'Package Name': this.qontakPackageName,
        'Qontak User ID': this.$auth.user?.id,
        'Qontak Role': this.$auth.user?.role,
        'Qontak Email': this.$auth.user?.email,
        Action: 'Single',
      })
    },
    onMarkAllAsRead() {
      this.storeQontakOneMixpanelMetric('Mark Notification As Read', {
        'Company SSO ID': this.getOrganizationForMetric()['Company ID'],
        'Company Name': this.getOrganizationForMetric()['Company Name'],
        'Package Name': this.qontakPackageName,
        'Qontak User ID': this.$auth.user?.id,
        'Qontak Role': this.$auth.user?.role,
        'Qontak Email': this.$auth.user?.email,
        Action: 'Bulk',
      })
    },
    onFilterChange(filter) {
      this.storeQontakOneMixpanelMetric('Filter Notification', {
        'Company SSO ID': this.getOrganizationForMetric()['Company ID'],
        'Company Name': this.getOrganizationForMetric()['Company Name'],
        'Package Name': this.qontakPackageName,
        'Qontak User ID': this.$auth.user?.id,
        'Qontak Role': this.$auth.user?.role,
        'Qontak Email': this.$auth.user?.email,
        'Notification Group': filter
          ? filter.replaceAll('_', ' ')
          : 'No Group Recorded',
      })
    },
    resetNotificationCenterFilter() {
      if (this.$refs.notificationCenter) return
      this.$refs.notificationCenter?.updateTabFilter(null)
    },
  },
}
</script>

<style scoped lang="scss">
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-down-enter-active {
  transition: all 0.3s ease-in-out;
}
.slide-down-leave-active {
  /* transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0); */
  transition: all 0.3s ease-in-out;
}
.slide-down-enter, .slide-down-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-60px);
  opacity: 0;
}
</style>
